enum Mutations {
  SET_SELECTED_TAG_IDS = 'setSelectedTagIds',
}

export default Mutations;
